import React from 'react';
import {connect} from 'react-redux'
import { Modal, Row, Input} from "antd";
import 'antd/lib/modal/style/css';
import getCRLReasons from "../../actions/getCRLReasons";
import {Button} from "antd";
import {SHOW_MSG} from "../../types";
import languages from "../../language/languages";
import {LockOutlined} from "@ant-design/icons";

class GenerateP12Modal extends React.Component {

    state={password:'',confirmPassword:''};

    checkPassword=()=>
    {
        if(!this.state.password || this.state.password==='' || this.state.password !== this.state.confirmPassword)
            this.props.dispatch({type: SHOW_MSG, payload: {message: languages[this.props.language].dontMatch,type:'error'}});
        else
            this.props.onOK(this.state.password);
    };

    render() {
        return (
            <Modal centered visible={this.props.modalType !== null} {...this.props.modalProps}>
                <Row className={'mb-10 text-center block'}>
                    <strong>{this.props.message} </strong>
                </Row>
                <Row className={'mb-10 text-center'}>
                    <Input.Password prefix={<LockOutlined className={'icon-font'} />} size={'large'}  autoComplete='new-password' placeholder={languages[this.props.language].password} value={this.state.password} onChange={(e)=>this.setState({password: e.target.value})}></Input.Password>
                </Row>
                <Row className={'mb-10 text-center'}>
                    <Input.Password prefix={<LockOutlined className={'icon-font'} />} size={'large'} autoComplete='new-password' placeholder={languages[this.props.language].confirmPassword} value={this.state.confirmPassword} onChange={(e)=>this.setState({confirmPassword: e.target.value})}></Input.Password>
                </Row>
                <Row className={'text-center block'}>
                    <Button onClick={this.checkPassword} type={'primary'}>{this.props.btnOK}</Button>
                    <Button onClick={this.props.onCancel} type={'primary'}>{this.props.btnCancel}</Button>
                </Row>
            </Modal>
        )
    }

}

function mapStateToProps(state) {
    return {
        language: state.auth.language
    }
}

export default connect(mapStateToProps, {getCRLReasons})(GenerateP12Modal);
